import { QueryClient, QueryKey } from '@tanstack/react-query';
import {
  isRootListQueryKey,
  isSettingsQueryKey,
  isViewQueryKey,
  isWorkflowQueryKey,
} from './query-refresh.business';

export const setupQueryClient = (): QueryClient =>
  new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        refetchOnWindowFocus: false,
        staleTime: Infinity,
      },
    },
  });

const queryClient = setupQueryClient();

export const updateQuery = (queryKey: QueryKey) => queryClient.invalidateQueries({ queryKey });

export const clearCacheQuery = (queryKey: QueryKey) => {
  queryClient.removeQueries({ queryKey });
  queryClient.resetQueries({ queryKey });
};

// Inside a workflow the root lists stay mounted behind the overlay, but they are not on screen.
export const refreshCurrentView = (isWorkflowActive: boolean): Promise<void> =>
  queryClient.refetchQueries(
    {
      type: 'active',
      predicate: ({ queryKey }) =>
        isViewQueryKey(queryKey) && !(isWorkflowActive && isRootListQueryKey(queryKey)),
    },
    { throwOnError: true }
  );

export const refreshRootData = (): Promise<void> => {
  queryClient.removeQueries({ predicate: ({ queryKey }) => isWorkflowQueryKey(queryKey) });
  return queryClient.invalidateQueries({
    predicate: ({ queryKey }) => isSettingsQueryKey(queryKey) || isRootListQueryKey(queryKey),
  });
};

export default queryClient;
